import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { ControlsType } from "types/ControlsType";

export default function useGetControls() {
  return useQuery({
    queryKey: ["controls"],
    queryFn: async () => {
      return axiosInstance.get(`/controls`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: ({ data }: { data: ControlsType }) => data,
    retry: false,
  });
}
